import {
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  NativeSelect,
  OutlinedInput,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocationsList } from "../Redux/products/slice";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {BASE_URL} from "../Redux/apiConfig"
import {
  getProductStateList,
  transferProduct,
  transportProduct,
  getProductNextStateList,
} from "../Redux/products/slice";

import { IntlProvider, FormattedMessage, useIntl } from 'react-intl';
import {Autocomplete } from '@mantine/core';
import { payload } from "../utils";

export const TAG_TRANSFORM_ACTION = "TRANSFORM_ACTION";
export const TAG_TRANSPORT_ACTION = "TRANSPORT_ACTION";

function TransportationModal({ toggle, modal, title, data, tag, onSave, dataLot }) {
  const dispatch = useDispatch();
  const { productStateList, locationsList, productNextStateList } = useSelector(
    (state) => state.products
  );

  const storedLanguage = localStorage.getItem("language");
  const selectedLanguage = useSelector((state) => state.language);
  const targetLanguage = storedLanguage ? storedLanguage.replace(/["']/g, '') : "en";
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [savingData, setSavingData] = useState(false);

  //new for Google API
    const searchLocations = async (query) => {
        if (!query) {
          setLocationSuggestions([]);
          return;
        }
  
        try {
          const res = await fetch(`${BASE_URL}/autocomplete?q=${encodeURIComponent(query)}&lang=${selectedLanguage}`);
          const data = await res.json();
          setLocationSuggestions(data.results || []);
        } catch (err) {
          console.error("Error Google API:", err);
        }
      };

  useEffect(() => {
    // Dispatch actions to fetch data when the modal is opened
    if (modal) {
        dispatch(getProductStateList());
        dispatch(getProductNextStateList());
    }
  }, [modal, dispatch]);


  const sortedLocations = locationsList
  .slice()
  .sort((a, b) => (a.location && b.location ? a.location.localeCompare(b.location) : 0));

  const sortedProductStates = productStateList
    .slice()
    .sort((a, b) => {
      // Sort by ActionId or product_ref_id to maintain correct sequence order
      const aId = a.ActionId || a.action_id || a.product_ref_id || 0;
      const bId = b.ActionId || b.action_id || b.product_ref_id || 0;
      return aId - bId;
    });

  const { categories } = useSelector((state) => state.options);
  const [fromPeriod, setFromPeriod] = useState(new Date().toISOString().split('T')[0]);
  const [toPeriod, setToPeriod] = useState(new Date().toISOString().split('T')[0]);

  const [physicalState, setPhysicalState] = useState("");
  const [location, setLocation] = useState("");
  const [country, setCountry] = useState();
  const [transportDescription, setTransportDescription] = useState("");
  const [city, setCity] = useState('');

  // Update state when data prop changes
  useEffect(() => {
    if (data) {
        dispatch(getProductStateList());
        dispatch(getProductNextStateList());

    }
  }, [data, dispatch, selectedLanguage]);


  function getMonthDifference(startDate, endDate) {
    return (
      endDate.getMonth() -
      startDate.getMonth() +
      12 * (endDate.getFullYear() - startDate.getFullYear())
    );
  }

  const saveData = () => {
    let FromPeriod = new Date(fromPeriod);
    let ToPeriod = new Date(toPeriod);
    setSavingData(true);

    let month = getMonthDifference(FromPeriod, ToPeriod);

    // Assuming locationsList is a dictionary with id and label
    //const selectedLocation = locationsList.find(value => value.location === location);
    const locationsIds = selectedLocation?selectedLocation.place_id : null;;

    if (tag === TAG_TRANSFORM_ACTION) {
      const productId = productStateList.find(state => state.ActionVerb_en === physicalState && state.id_category === data.category)?.product_ref_id || null;
      const payload = {
        ...data, 
        physicalState: physicalState,
        //location: location,
        period: `${fromPeriod} - ${toPeriod}`,
        country: country,
        location_id: locationsIds,
        product_ref_id: productId,
        product_next_id: productId,
        transportDescription, // Include the new description field
      };
      dispatch(transferProduct(payload));
    } else {
      const payload = {
        ...data,
        physicalState: physicalState,
        //location: location,
        period: `${fromPeriod} - ${toPeriod}`,
        country: country,
        location_id: locationsIds,
        transportDescription, // Include the new description field
      };
      dispatch(transportProduct({ ...payload, location }));
    }

    // clearData();

    // Call the onSave callback function
    onSave(payload, toggle);
    setSavingData(false);
  };

  const clearData = () => {
    setFromPeriod("");
    setToPeriod("");
    setPhysicalState("");
    setLocation("");
    setTransportDescription(""); // Clear the transport description field
  };

  const intl = useIntl();

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} style={{ height: "auto" }}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Grid container spacing={2}>
            {(tag === TAG_TRANSFORM_ACTION || tag === TAG_TRANSPORT_ACTION) && (
              <Grid item xs={12}>
                <Autocomplete
                  label={intl.formatMessage({ id: "product.location" })}
                  placeholder={intl.formatMessage({ id: "product.location" })}
                  data={locationSuggestions.map(loc => ({ value: loc.description, id: loc.place_id }))}
                  value={city}
                  onChange={(value) => {
                    setCity(value);
                    const selected = locationSuggestions.find(loc => loc.description === value);
                    if (selected) {
                      setSelectedLocation(selected);
                    }
                    searchLocations(value);
                  }}
                  dropdownComponent="ScrollArea"
                  sx={{
                    '.mantine-Autocomplete-dropdown': { maxHeight: '200px', height: 'auto' },
                    '.mantine-Autocomplete-item': { whiteSpace: 'nowrap' },
                  }}
                />
              </Grid>
            )}
            {tag === TAG_TRANSFORM_ACTION && (
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="physical-state-select">
                    <FormattedMessage id="product.physicalstate" />
                  </InputLabel>
                  <Select
                    native
                    value={physicalState}
                    onChange={(e) => setPhysicalState(e.target.value)}
                    input={
                      <OutlinedInput
                        label={intl.formatMessage({ id: "product.physicalstate" })}
                        id="physical-state-select"
                      />
                    }
                  >
                    <option aria-label="None" value="" />
                    {sortedProductStates
                      .filter(state => state.id_category === data.category)
                      .map((state, index) => (
                        <option
                          key={state.ActionVerb}
                          value={state.ActionVerb_en}
                          disabled={state.product_ref_id <= data.product_ref_id}
                          style={{
                            color: state.product_ref_id > data.product_ref_id ? 'inherit' : '#ccc',
                            fontStyle: state.product_ref_id > data.product_ref_id ? 'normal' : 'italic',
                          }}
                        >
                          {index + 1}: {state.ActionVerb}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField
                id="transport-description"
                label={intl.formatMessage({ id: "product.transportDescription" })}
                fullWidth
                multiline
                rows={4}
                value={transportDescription}
                onChange={(e) => setTransportDescription(e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ marginBottom: '6px', fontSize: '0.85rem', color: '#555', fontWeight: 500 }}>
                <FormattedMessage id="product.period1" />
              </div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label={intl.formatMessage({ id: "product.period.from" })}
                    type="date"
                    fullWidth
                    value={fromPeriod}
                    onChange={(e) => setFromPeriod(e.target.value)}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label={intl.formatMessage({ id: "product.period.to" })}
                    type="date"
                    fullWidth
                    value={toPeriod}
                    onChange={(e) => setToPeriod(e.target.value)}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => saveData()}>
            {tag === TAG_TRANSFORM_ACTION ? <FormattedMessage id="myprods.action.transform" /> : <FormattedMessage id="myprods.action.transport" />}
          </Button>{" "}
          <Button
            color="secondary"
            onClick={() => {
              clearData();
              onSave();
              toggle();
            }}
          >
            <FormattedMessage id="button.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default TransportationModal;
